import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';

@Pipe({ name: 'calcMonth' })
export class CalcMonthPipe implements PipeTransform {

    constructor(private utilitiesService: UtilitiesService) {}

    public transform(value: string, args?: any): any {
        if (value) {
            return this.utilitiesService.calculateMonth(value, 'number');
        }
    }

}
